import React from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'

const PagePaper = (props) => (
  <Box sx={{ backgroundColor: 'background.default', p: 1.5, borderRadius: 3 }}>
    <Paper
      sx={{
        borderRadius: 3,
        p: 3,
        border: '1px solid #E2E8F0',
        boxShadow:
          '0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 8px rgba(15, 23, 42, 0.06)',
        overflow: 'hidden',
      }}
    >
      {props.children}
    </Paper>
  </Box>
)

export default PagePaper
